import React, { forwardRef } from "react";

import {
  AddBox,
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
  Receipt,
} from "@material-ui/icons";
import MaterialTable from "material-table";
import Swal from "sweetalert2";

import { functionBaseUrl, axiosWithToken } from "../../../common/firebase";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  Receipt: forwardRef((props, ref) => <Receipt {...props} ref={ref} />),
};

function EnterpriseInstructorsListComponent({ accounts }) {
  const rows = React.useMemo(
    () =>
      accounts.map((a) => ({
        ...a,
        studentsCount: Array.isArray(a.students)
          ? a.students.length
          : Number(a?.studentsCount || 0),
        sessionCount: Array.isArray(a.sessionIds)
          ? a.sessionIds.length
          : Number(a?.sessionCount || 0),
      })),
    [accounts]
  );

  const columns = [
    {
      field: "name",
      title: "Name",
      render: (row) => `${row.firstName ?? ""} ${row.lastName ?? ""}`.trim(),
      // make it searchable by a compact value (no arrays involved)
      customFilterAndSearch: (term, row) =>
        `${row.firstName ?? ""} ${row.lastName ?? ""}`
          .toLowerCase()
          .includes(term.toLowerCase()),
    },
    { field: "email", title: "Email Address" },
    {
      field: "studentsCount",
      title: "Students",
      type: "numeric",
      searchable: false, // avoid adding to big searchText
    },
    {
      field: "sessionCount",
      title: "Swings",
      type: "numeric",
      searchable: false,
    },
  ];

  const handleDelete = async (event, data) => {
    const result = await Swal.fire({
      title: `<p style="font-size:70%;">Are you sure you want to remove ${data.firstName} ${data.lastName} (${data.email})?</p>`,
      icon: "warning",
      confirmButtonText: "Yes",
      showCancelButton: true,
      cancelButtonText: "No",
      cancelButtonColor: "red",
      allowOutsideClick: false,
    });

    if (!result.isConfirmed) return;

    try {
      await axiosWithToken(
        `${functionBaseUrl}/api/usersEnterprise/instructors/remove`,
        {
          method: "post",
          data: { id: data.uid },
        }
      );
      await Swal.fire({
        title: '<p style="font-size:70%;">Removed successfully</p>',
        icon: "success",
        confirmButtonText: "Ok",
        allowOutsideClick: false,
        timer: 2000,
      });
      window.location.reload();
    } catch (e) {
      Swal.fire('<p style="font-size:70%;">Error occured</p>');
    }
  };

  return (
    <MaterialTable
      style={{ marginTop: 10, marginBottom: 10 }}
      icons={tableIcons}
      title=""
      columns={columns}
      data={rows}
      options={{
        selection: false,
        sorting: true,
        search: true,
        paging: true,
        // prevent odd rows from returning undefined styles:
        rowStyle: (x) =>
          x.tableData.id % 2 ? { backgroundColor: "#f2f2f2" } : {},
      }}
      actions={[
        (rowData) => ({
          tooltip: "Remove",
          icon: tableIcons.Delete,
          disabled: !!rowData?.subscriptionType?.includes("enterprise_master"),
          onClick: handleDelete,
        }),
      ]}
    />
  );
}

export const EnterpriseInstructorsList = EnterpriseInstructorsListComponent;
